import React, { useMemo, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { adminAPI, getMediaUrl } from '../../services/blogApi';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({ value, onChange }) => {
  const quillRef = useRef<ReactQuill>(null);

  const imageHandler = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return;

      try {
        const result = await adminAPI.uploadImage(file);
        const url = getMediaUrl(result.url);
        const editor = quillRef.current?.getEditor();
        const range = editor?.getSelection(true);

        if (editor && range) {
          editor.insertEmbed(range.index, 'image', url);
          editor.setSelection({ index: range.index + 1, length: 0 });
        }
      } catch (err) {
        alert(err instanceof Error ? err.message : 'Image upload failed');
      }
    };
    input.click();
  };

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [2, 3, false] }],
          ['bold', 'italic', 'underline'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link', 'image'],
          ['clean'],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <div className="admin-quill rounded-xl overflow-hidden border border-gray-300 dark:border-gray-600 bg-white dark:bg-slate-900">
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        placeholder="Write your article content..."
      />
    </div>
  );
};

export default RichTextEditor;
